var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { SplashScreen, useAuth, useService } from '@tenderd/track-web-utils';
import { Button, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './GroupServiceProvider.css';
export var GroupServiceContext = React.createContext({});
export var useGroupService = function () {
    return React.useContext(GroupServiceContext);
};
export var GroupServiceProvider = function (props) {
    var _a = __read(useState(), 2), group = _a[0], setGroup = _a[1];
    var _b = __read(useState(0), 2), totalGroupEquipmentCount = _b[0], setTotalGroupEquipmentCount = _b[1];
    var _c = __read(useState(true), 2), loading = _c[0], setLoading = _c[1];
    var service = useService();
    var user = useAuth().user;
    var params = useParams();
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var group_1, equipmentsCount, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    return [4 /*yield*/, service.server.getGroupById(params.groupId)];
                case 1:
                    group_1 = _a.sent();
                    setGroup(group_1);
                    if (!group_1) return [3 /*break*/, 3];
                    return [4 /*yield*/, service.server.getGroupEquipmentsCount(group_1.id)];
                case 2:
                    equipmentsCount = _a.sent();
                    setTotalGroupEquipmentCount(equipmentsCount.count);
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    message.error(error_1.message);
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var gService = {
        group: group,
        setGroup: setGroup,
        loading: loading,
        loadData: loadData,
        totalGroupEquipmentCount: totalGroupEquipmentCount,
    };
    useEffect(function () {
        if (user && params.groupId) {
            setLoading(true);
            loadData();
        }
    }, [params.groupId, user]);
    var renderNoGroup = function () {
        var history = useHistory();
        return (React.createElement("div", { className: "group-not-found-container" },
            React.createElement("div", { className: "card" },
                React.createElement("div", { className: "left" },
                    React.createElement("img", { src: "https://storage.googleapis.com/tenderd-ui/assets/Oops!%20404%20Error%20with%20a%20broken%20robot.gif", alt: "404" })),
                React.createElement("div", { className: "right" },
                    React.createElement("h1", null, "Group not found"),
                    React.createElement("p", null, "Group with specified id was not found. Please make sure to use a correct and a valid id"),
                    React.createElement(Button, { className: "allow-btn", type: "primary", onClick: function () { return history.push("/groups"); } }, "Go Back")))));
    };
    return (React.createElement(GroupServiceContext.Provider, { value: gService }, loading ? React.createElement(SplashScreen, null) : group ? props.children : renderNoGroup()));
};
